import { render } from "./EditAddBescStep1.vue?vue&type=template&id=6496487e&ts=true"
import script from "./EditAddBescStep1.vue?vue&type=script&lang=ts"
export * from "./EditAddBescStep1.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__